/* unplugin-vue-components disabled */import { render } from "./About.vue?vue&type=template&id=1ae8a7be"
const script = {}

import exportComponent from "C:\\qiji\\sunyu\\code\\java\\兴安盟气象完整\\xam-all\\xam-meteorological\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__